"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorksiteStatus = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var autoId = 0;
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('WorksiteStatus'), (0, recompose_1.mapProps)(function (props) { return (__assign(__assign({}, props), { componentId: props.id || "id-".concat(++autoId) })); }), recompose_1.pure);
exports.WorksiteStatus = enhance(function (_a) {
    var icon = _a.icon, label = _a.label, style = _a.style, elementStyle = _a.elementStyle, error = _a.error, className = _a.className, elementClassName = _a.elementClassName, value = _a.value, defaultChecked = _a.defaultChecked, componentId = _a.componentId, disabled = _a.disabled, rest = __rest(_a, ["icon", "label", "style", "elementStyle", "error", "className", "elementClassName", "value", "defaultChecked", "componentId", "disabled"]);
    return (React.createElement("div", { className: classNames('worksite-status-field', error && 'error', className), style: style },
        React.createElement("div", { className: 'input' },
            React.createElement("input", __assign({ id: componentId, type: "radio", name: label, value: value, disabled: disabled, checked: defaultChecked }, rest)),
            React.createElement("label", { htmlFor: componentId, className: elementClassName, style: elementStyle },
                !!icon && React.createElement("i", { className: "fa ".concat(icon), "aria-hidden": "true" }),
                !!label && label)),
        error &&
            error.length > 0 && (React.createElement("div", { className: 'errors' }, error.map(function (err, i) { return (React.createElement("span", { key: i, className: 'error-message' }, err)); })))));
});
//# sourceMappingURL=index.js.map